import { getDefaultSubscriptionPlanPropertiesAsync } from './getDefaultSubscriptionPlanPropertiesAsync'

export const getDefaultSubscriptionPlanIdAsync = async (refresh = false) => {
  const { id } = await getDefaultSubscriptionPlanPropertiesAsync(refresh)

  return id
}
